import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, TrendingUp, HeartHandshake, Globe } from 'lucide-react';
import { useApp } from '../context/AppContext';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const AnimatedTopBar = () => {
  const { currentDate } = useApp();

  const formatDate = (date) => {
    return date.toLocaleDateString('es-CO', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const indicators = [
    { icon: TrendingUp, label: "Incremento en Ventas", value: "87%" },
    { icon: Globe, label: "Presencia Nacional e internacional", value: "5 Naciones" },
    { icon: HeartHandshake, label: "Procesos Finiquitados", value: "7645" }
  ];

  return (
    <div className="bg-gradient-to-r from-blue-700 via-blue-600 to-blue-500 text-white py-2 overflow-hidden">
      <motion.div
        className="flex items-center gap-8 whitespace-nowrap"
        animate={{
          x: [-1200, 1900]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4" />
            <span className="font-semibold">{formatDate(currentDate)}</span>
          </div>
          
          {indicators.map((indicator, index) => (
            <div key={index} className="flex items-center gap-2">
              <indicator.icon className="w-4 h-4 text-yellow-500" />
              <span className="font-medium">{indicator.label}:</span>
              <span className="bg-white/15 px-2 py-1 rounded-full text-sm font-bold text-white-100">
                {indicator.value}
              </span>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default AnimatedTopBar;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.